import { useState } from "react";

const AddNote = ({ handleAddNote }) => {
    const [noteText, setNoteText] = useState('');
    const characterLimit = 255;

    const handleChange = (event) => {
        if((characterLimit - event.target.value.length) >= 0){
            setNoteText(event.target.value);
        }
    };

    const handleSaveClick = () => {
        if (noteText.trim().length > 0) {
            handleAddNote(noteText);
            setNoteText('');
        }
    }

    return (
        <div className="note new">
            <textarea
                rows="8"
                cols="10"
                value={noteText}
                placeholder="Type to add a note..."
                onChange={handleChange}
            ></textarea>
            <div className="note_footer">
                <small>{characterLimit - noteText.length} Remaining</small>
                <button className="save" onClick={handleSaveClick}>Save</button>
            </div>
        </div>
    );
}

export default AddNote;